// Care+ UI shared by Choose Plan and the reorder offer.

export const CARE_PLUS_ORANGE_GRADIENT = "linear-gradient(90deg, rgb(245,146,0) 0%, rgb(255,187,41) 100%)";

export const CarePlusTick = ({ className = "mt-[6px]" }: { className?: string }) => (
  <span className={`${className} flex size-[9px] shrink-0 items-center justify-center text-[#f59603]`}>
    <svg viewBox="0 0 10 10" width="9" height="9" aria-hidden="true" focusable="false">
      <path d="M1 5.4 3.4 8 9 1.6" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

/** Figma 38938:684. */
export const CarePlusRadio = ({ checked }: { checked: boolean }) => (
  <span
    aria-hidden="true"
    className={`flex size-[20px] shrink-0 items-center justify-center rounded-full border-2 border-solid bg-white ${checked ? "border-[#f59603]" : "border-[#d1d5ce]"}`}
  >
    {checked && <span className="size-[10px] rounded-full" style={{ background: CARE_PLUS_ORANGE_GRADIENT }} />}
  </span>
);
